import { Directive, ElementRef, Input, Renderer2 } from "@angular/core";

/**
 * Diretiva para botões asíncronos (por ex: que mandam requests para o backend)
 */
@Directive({
    selector: "[async-btn]",
    exportAs: "async-btn"
})
export class AsyncButtonDirective {

    @Input() loadingLabel = 'Carregando';

    btnLabel;

    waiting: boolean;

    constructor(private renderer: Renderer2, private el: ElementRef) {
    }

    wait() {
        // this.renderer.setElementProperty(this.el.nativeElement, 'disabled', true);
        this.waiting = true;
        this.btnLabel = this.el.nativeElement.innerHTML;
        this.el.nativeElement.textContent = '';
        let icon = __ngRendererCreateElementHelper(this.renderer, this.el.nativeElement, 'i');
        this.renderer.addClass(icon, 'fa');
        this.renderer.addClass(icon, 'fa-spinner');
        this.renderer.addClass(icon, 'fa-spin');
        __ngRendererCreateTextHelper(this.renderer, this.el.nativeElement, ' ' + this.loadingLabel);
    }

    release() {
        // TODO Não tira o status disabled pois o button host pode ter uma propriedade [disabled] própria, que pode ser
        // verdadeira nesse momento. Deve ser possível veriricar se esse caso ocorre e só mudar essa propriedade se
        // não estiver definida no host
        // this.renderer.setElementProperty(this.el.nativeElement, 'disabled', false);
        if (this.waiting) {
            if (this.btnLabel) {
                this.el.nativeElement.textContent = '';
                this.el.nativeElement.innerHTML = this.btnLabel;
            }
            this.waiting = false;
        }
    }
}

type AnyDuringRendererMigration = any;

function __ngRendererSplitNamespaceHelper(name: AnyDuringRendererMigration) {
    if (name[0] === ":") {
        const match = name.match(/^:([^:]+):(.+)$/);
        return [match[1], match[2]];
    }
    return ["", name];
}

function __ngRendererCreateElementHelper(renderer: AnyDuringRendererMigration, parent: AnyDuringRendererMigration,
                                         namespaceAndName: AnyDuringRendererMigration) {
    const [namespace, name] = __ngRendererSplitNamespaceHelper(namespaceAndName);
    const node = renderer.createElement(name, namespace);
    if (parent) {
        renderer.appendChild(parent, node);
    }
    return node;
}

function __ngRendererCreateTextHelper(renderer: AnyDuringRendererMigration, parent: AnyDuringRendererMigration,
                                      value: AnyDuringRendererMigration) {
    const node = renderer.createText(value);
    if (parent) {
        renderer.appendChild(parent, node);
    }
    return node;
}
